import { render, staticRenderFns } from "./WelcomeWizardMediaPanel.vue?vue&type=template&id=72364a8c&scoped=true"
import script from "./WelcomeWizardMediaPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomeWizardMediaPanel.vue?vue&type=script&setup=true&lang=js"
import style0 from "./WelcomeWizardMediaPanel.vue?vue&type=style&index=0&id=72364a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72364a8c",
  null
  
)

export default component.exports